import m from "../../geodata/es2015/greenlandHigh";
window.am4geodata_greenlandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/greenlandHigh.js
// module id = null
// module chunks = 